// Components==============
import React, { createContext, useMemo, useState } from 'react';
// =========================

type GlobalReflectionContextType = {
  selectedReflection: number;
  setSelectedReflection: React.Dispatch<React.SetStateAction<number>>;
};

export const GlobalReflectionContext = createContext(
  {} as GlobalReflectionContextType
);

export default function GlobalReflection({
  children,
}: {
  children: React.ReactNode;
}) {
  const [selectedReflection, setSelectedReflection] = useState(0);

  const value = useMemo(
    () => ({
      selectedReflection,
      setSelectedReflection,
    }),
    [selectedReflection]
  );

  return (
    <GlobalReflectionContext.Provider value={value}>
      {children}
    </GlobalReflectionContext.Provider>
  );
}
